import { forwardRef } from 'react';

import { IconProps } from './';

export const CircleIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, fill = 'currentColor', strokeWidth, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} fill={fill} stroke="currentColor" strokeWidth={strokeWidth}>
      <circle cx="12" cy="12" r="10" />
    </svg>
  );
});

export default CircleIcon;
